import TimeHelper from '../../../../utils/time';

export const formatOrderDeliveredDate = (orderDeliveredDate?: string) => {
    if (
        !orderDeliveredDate ||
        orderDeliveredDate === '0001-01-01T00:00:00' ||
        orderDeliveredDate === '' ||
        orderDeliveredDate === ' - ' ||
        new Date(orderDeliveredDate).toString() === 'Invalid Date'
    ) {
        return ' - ';
    }
    return TimeHelper.formatDateHour(orderDeliveredDate);
};

export const extractShippingListItems = (shippingListModel: any[]) => {
    return (shippingListModel || []).map((model: any) => model.shippingListItems || []);
};

export const parseCustomerOrderItems = (items: any[]) => {
    return items.map((item: any) => {
        const saleOrder = item.saleOrderModel || {};
        const shippingLists = item.shippingListModel || [];
        const shippingListNos = shippingLists.map((model: any) => model.shippingListNo || '-');
        const orderTypes = shippingLists.map((model: any) => model.shipmentOwner || '-');

        return {
            rowId: String(saleOrder.orderId ?? saleOrder.orderNumber ?? ''),
            orderNumber: saleOrder.orderNumber || '-',
            orderDate: saleOrder.orderDate || ' - ',
            orderDeliveredDate: saleOrder.orderDeliveredDate || ' - ',
            grandTotal: saleOrder.grandTotal ? saleOrder.grandTotal : '-',
            orderStatusId: saleOrder.orderStatusId || '-',
            paymentMethodName: saleOrder.paymentInfos?.[0]?.paymentMethodName || ' -  ',
            shippingListItems: extractShippingListItems(shippingLists),
            orderStatusName: saleOrder.orderStatusDescription || '-',
            shippingListNo: shippingListNos.length > 0 ? shippingListNos : ['-'],
            shippingListNoDisplay: shippingListNos.length > 0 ? shippingListNos.join(', ') : '-',
            orderTypeDisplay: orderTypes.length > 0 ? orderTypes.join(', ') : '-',
            passingTime: saleOrder.passingTime ?? '-',
            orderId: saleOrder.orderId || '-',
            shippingListModel: shippingLists,
        };
    });
};

export const flattenOrdersForExcel = (items: any[]) => {
    return items.flatMap((item: any) => {
        const saleOrder = item.saleOrderModel || {};
        const shippingLists = item.shippingListModel?.length > 0 ? item.shippingListModel : [null];

        return shippingLists.map((shipping: any) => ({
            orderNumber: saleOrder.orderNumber || '-',
            customerOrderShippingNumber: shipping?.shippingListNo || '-',
            orderDate: TimeHelper.formatDateHour(saleOrder.orderDate || ''),
            orderDeliveredDate: formatOrderDeliveredDate(saleOrder.orderDeliveredDate),
            elapsedTime: saleOrder.passingTime >= 30 ? '30+' : String(saleOrder.passingTime ?? '-'),
            grandTotal: saleOrder.grandTotal ? saleOrder.grandTotal : '-',
            orderStatusName: saleOrder.orderStatusDescription || '-',
            paymentMethodName: saleOrder.paymentInfos?.[0]?.paymentMethodName || ' -  ',
            customerOrderType: shipping?.shipmentOwner || '-',
        }));
    });
};

export const parseSpecialAndColorCode = (data: string): { specialCode: string; colorCode: string } | null => {
    if (!data.includes('-')) {
        return null;
    }

    const splitData = data.trim().split('-');
    return {
        specialCode: splitData[0].trim(),
        colorCode: splitData[1].trim(),
    };
};

export const applyCurrencyToOrderRows = (rows: any[], currency: string) =>
    rows.map((row: any) => ({
        ...row,
        grandTotal: row.grandTotal && row.grandTotal !== '-' ? `${row.grandTotal} ${currency}` : row.grandTotal,
    }));

export const mapRptTopicOptions = (items: any[]) =>
    items.map((item: any) => ({
        value: item.rptTopicId,
        text: item.topicName,
        days: item.topicControlDays,
    }));

export const buildOrderQueryParams = (options: {
    customerId: number;
    rowsPerPage: number;
    page: number;
    searchedText: string | null;
    documentType: number;
    barcode: string;
    barcodeArray: any[];
    contactReasonDays: number;
}) => {
    const { customerId, rowsPerPage, page, searchedText, documentType, barcode, barcodeArray, contactReasonDays } =
        options;
    let params: any = {};

    if ((searchedText || '').trim().length === 0 && barcode !== '') {
        params = {
            CustomerId: customerId,
            Take: rowsPerPage,
            Skip: page,
            Barcodes: barcode.split(','),
        };
    } else if (documentType === 1 && searchedText && searchedText !== null) {
        params = {
            CustomerId: customerId,
            Take: rowsPerPage,
            Skip: page,
            Barcodes: (searchedText || '').trim().split(','),
        };
    } else if (documentType === 2 && barcodeArray.length > 0) {
        params = {
            CustomerId: customerId,
            Take: rowsPerPage,
            Skip: page,
            Barcodes: barcodeArray,
        };
    } else {
        params = {
            CustomerId: customerId,
            take: rowsPerPage,
            skip: page,
        };
    }

    if (contactReasonDays !== -1) {
        params.OrderDeliveredStartDate = new Date(Date.now() - contactReasonDays * 24 * 60 * 60 * 1000);
        params.OrderDeliveredEndDate = new Date(Date.now());
    }

    return params;
};
